import React, { useEffect, useState, useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import styled from "styled-components";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/effect-coverflow";
import "swiper/css/pagination";

import { EffectCoverflow, Pagination, Navigation } from "swiper";
import { RATypography } from "@/components/customs";
import { Col, Row, Image, Grid } from "antd";
import { IconArrowLeftGray } from "@/components/svgs/IconArrowLeftGray";
import { IconArrowRightGray } from "@/components/svgs/IconArrowRightGray";
import { IconExpand } from "@/components/svgs/IconExpand";
import { SvgClose } from "@/assets/icons";

const { useBreakpoint } = Grid;

// Hook
function useWindowSize() {
	// Initialize state with undefined width/height so server and client renders match
	const [windowSize, setWindowSize] = useState({
		width: undefined,
		height: undefined,
	});

	useEffect(() => {
		// only execute all the code below in client side
		// Handler to call on window resize
		function handleResize() {
			// Set window width/height to state
			setWindowSize({
				width: window.innerWidth,
				height: window.innerHeight,
			});
		}

		// Add event listener
		window.addEventListener("resize", handleResize);

		// Call handler right away so state gets updated with initial window size
		handleResize();

		// Remove event listener on cleanup
		return () => window.removeEventListener("resize", handleResize);
	}, []); // Empty array ensures that effect is only run on mount
	return windowSize;
}

export const AircraftImages = ({ aircrafts = [], typeName = "", fullpageApi }) => {
	const screenSize = useWindowSize();
	const sliderRef = useRef(null);
	const [imagesList, setImagesList] = useState([]);
	const [activeAircraft, setActiveAircraft] = useState();
	const [imgPreviewUrl, setImgPreviewUrl] = useState("");
	const [loaded, setLoaded] = useState(false);

	useEffect(() => {
		setTimeout(() => {
			setLoaded(true);
		}, 1000);
	}, []);

	useEffect(() => {
		if (aircrafts?.length > 0) {
			let finalImages = [];
			aircrafts[0].images?.map((image) => {
				finalImages.push({
					...image,
					aircraft_id: aircrafts[0]?._id,
					aircraft_name: aircrafts[0]?.name,
					tail_number: aircrafts[0]?.tail_number,
				});
			});
			setImagesList(finalImages);

			if (!activeAircraft) {
				setActiveAircraft(aircrafts[0]?.tail_number);
			}
		}
	}, [aircrafts]);

	const onChangeAircraftTailNumer = (tailNum) => {
		if (tailNum !== activeAircraft) {
			let numIndex = aircrafts.findIndex((v) => v.tail_number === tailNum);
			if (numIndex > -1) {
				let finalImages = [];
				aircrafts[numIndex].images?.map((image) => {
					finalImages.push({
						...image,
						aircraft_id: aircrafts[numIndex]?._id,
						aircraft_name: aircrafts[numIndex]?.name,
						tail_number: aircrafts[numIndex]?.tail_number,
					});
				});
				setImagesList(finalImages);

				setActiveAircraft(tailNum);
			}
		}
	};

	const onPrevPreviewImage = () => {
		const currentIndex = imagesList.findIndex((v) => v.url === imgPreviewUrl);
		if (currentIndex <= 0) {
			const item = imagesList[imagesList.length - 1];
			setImgPreviewUrl(item?.url);
		} else {
			const item = imagesList[currentIndex - 1];
			setImgPreviewUrl(item?.url);
		}
	};

	const onNextPreviewImage = () => {
		const currentIndex = imagesList.findIndex((v) => v.url === imgPreviewUrl);
		if (currentIndex >= imagesList?.length - 1) {
			const item = imagesList[0];
			setImgPreviewUrl(item?.url);
		} else {
			const item = imagesList[currentIndex + 1];
			setImgPreviewUrl(item?.url);
		}
	};

	return (
		<Container>
			{loaded && (
				<WrapperSwiper>
					<WrapperMainImage>
						<div style={{ position: "relative", height: "100%" }}>
							<div className="swiper-button-prev">
								<WrapperIcon>
									<IconArrowLeftGray color="#fff" />
								</WrapperIcon>
							</div>
							<div className="swiper-button-next">
								<WrapperIcon>
									<IconArrowRightGray color="#fff" />
								</WrapperIcon>
							</div>
							<Swiper
								ref={sliderRef}
								speed={800}
								effect="coverflow"
								grabCursor={true}
								centeredSlides={true}
								slidesPerView="auto"
								loop={imagesList.length > 1 ? true : false}
								loopedSlides={3}
								coverflowEffect={{
									rotate: 0,
									stretch: screenSize?.width > 3000 ? -240 : screenSize?.width > 2400 ? -208 : -152,
									depth: 300,
									modifier: 2,
									slideShadows: true,
								}}
								navigation={{
									enabled: true,
									nextEl: ".swiper-button-next",
									prevEl: ".swiper-button-prev",
								}}
								modules={[EffectCoverflow, Pagination, Navigation]}
								className="mySwiper"
							>
								{imagesList.length > 0
									? imagesList.map((item, index) => {
											return (
												<SwiperSlide
													key={`aircraft-image-${index}`}
													className="custom-swiper-slider"
													onClick={() => {
														if (!imgPreviewUrl) {
															setImgPreviewUrl(item?.url);
														}
													}}
												>
													<SlideImage
														key={index}
														item={item}
														fullpageApi={fullpageApi}
														imgPreviewUrl={imgPreviewUrl}
														setImgPreviewUrl={setImgPreviewUrl}
														onPrevPreviewImage={onPrevPreviewImage}
														onNextPreviewImage={onNextPreviewImage}
													/>
												</SwiperSlide>
											);
										})
									: null}
							</Swiper>
						</div>
					</WrapperMainImage>
					<WrapperThumbImages>
						<WrapperAicraftName>
							<RATypography
								variant="h2"
								color="#fff"
								style={{
									fontSize: "44px",
									lineHeight: "58px",
								}}
							>
								{typeName || ""}
							</RATypography>
							<WrapperAircraftDetails>
								<Row justify="center" align="middle" gutter={[20, 20]}>
									{aircrafts?.length > 0
										? aircrafts?.map((item, index) => (
												<Col key={`aircraft-images-${index}`}>
													<WrapperConfiguration
														active={item?.tail_number === activeAircraft}
														onClick={() => onChangeAircraftTailNumer(item?.tail_number)}
													>
														<RATypography
															variant="sub-heading4"
															color={
																item?.tail_number === activeAircraft
																	? "#FFB11A"
																	: "#a8a8a8"
															}
															style={{
																transition: "all 0.6s ease-in-out",
															}}
														>
															{item?.tail_number}
														</RATypography>
													</WrapperConfiguration>
												</Col>
											))
										: null}
								</Row>
							</WrapperAircraftDetails>
						</WrapperAicraftName>
					</WrapperThumbImages>
				</WrapperSwiper>
			)}
		</Container>
	);
};

const SlideImage = ({ item, imgPreviewUrl, setImgPreviewUrl, onPrevPreviewImage, onNextPreviewImage, fullpageApi }) => {
	const slideRef = useRef();
	return (
		<>
			<CustomAntdImage
				ref={slideRef}
				src={item?.url}
				width="100%"
				height="100%"
				alt="aircraft-image"
				id={item?._id}
				preview={{
					movable: true,
					minScale: 1,
					maxScale: 5,
					toolbarRender: () => <></>,
					onVisibleChange: (visible) => {
						fullpageApi?.setAllowScrolling(!visible);
						// reset preview image
						if (!visible && imgPreviewUrl) {
							setImgPreviewUrl("");
						}
					},
					closeIcon: () => <></>,
					imageRender: (node) => {
						return (
							<PreviewAntdImage>
								<ButtonClosePreview>
									<div
										onClick={() => {
											const slideImage =
												document.getElementsByClassName("ant-image-preview-close");
											if (slideImage?.length > 0) {
												slideImage[0].click();
											}
										}}
									>
										<SvgClose />
									</div>
								</ButtonClosePreview>
								<ArrowLeftButton>
									<WrapperIcon
										onClick={(e) => {
											e.stopPropagation();
											onPrevPreviewImage("");
										}}
									>
										<IconArrowLeftGray />
									</WrapperIcon>
								</ArrowLeftButton>
								<WrapperInside>
									{{
										...node,
										props: {
											...node.props,
											src: imgPreviewUrl,
										},
									}}
								</WrapperInside>
								<ArrowRightButton>
									<WrapperIcon
										onClick={(e) => {
											e.stopPropagation();
											onNextPreviewImage();
										}}
									>
										<IconArrowRightGray />
									</WrapperIcon>
								</ArrowRightButton>
							</PreviewAntdImage>
						);
					},
				}}
			/>
			<WrapperExpandButton
				onClick={(e) => {
					const slideImage = document.getElementById(item?._id);
					if (slideImage) {
						slideImage.click();
					}
				}}
			>
				<WrapperInsideExpand>
					<IconExpand />
				</WrapperInsideExpand>
			</WrapperExpandButton>
		</>
	);
};

const Container = styled.div`
	width: 100%;
	height: 100vh;
	background: #000;
	position: relative;
	background-image: url("/images/aircraft-detail/background-coverflow.png");
	background-position: center;
	background-repeat: no-repeat;
	background-size: auto;
	.swiper {
		width: 100%;
		height: 100%;
	}
	.swiper-slide {
		text-align: center;
		font-size: 18px;
		background: transparent;
		/* Center slide text vertically */
		display: flex;
		justify-content: center;
		align-items: center;
		border-radius: 8px;
	}
	.swiper-slide img {
		display: block;
		width: 100%;
		height: 100%;
		object-fit: cover;
	}
	.swiper {
		width: 100%;
		height: 300px;
		margin-left: auto;
		margin-right: auto;
	}
	.swiper-slide {
		background-size: cover;
		background-position: center;
	}
	.mySwiper2 {
		height: 100%;
		width: 100vw;
	}
	.mySwiper {
		height: 100%;
		box-sizing: border-box;
		transition: max-height 0.3s ease-in-out;
	}
	/* .mySwiper .swiper-slide {
        width: 50vw !important;
        height: 100%;
    } */
	.mySwiper .swiper-slide-thumb-active {
		opacity: 1;
	}
	.swiper-slide img {
		display: block;
		width: 100%;
		height: 100%;
		object-fit: cover;
	}
	.mySwiper .swiper-slide-prev {
		background: transparent;
	}
	.mySwiper .swiper-slide-next {
		background: transparent;
	}
	.mySwiper .swiper-slide-shadow-left {
		border-radius: 8px;
	}
	.mySwiper .swiper-slide-shadow-right {
		border-radius: 8px;
	}
`;
const CustomAntdImage = styled(Image)`
	border-radius: 8px;
	pointer-events: none;
`;
const PreviewAntdImage = styled.div`
	position: relative;
	background-color: #000;
	width: 70vw;
	height: 80%;
	border-radius: 24px;
	padding: 60px;
`;
const WrapperInside = styled.div`
	display: inline-block;
	overflow: hidden;
	width: 100%;
	height: 100%;
	border-radius: 12px;
	.ant-image-preview-img {
		display: flex;
		margin: auto;
		max-height: 100% !important;
		max-width: 100% !important;
		display: block;
		object-fit: contain;
		border-radius: 12px !important;
		border-radius: calc(5vw + 5vh);
	}
`;
const WrapperSwiper = styled.div`
	width: 100%;
	height: 100%;
	position: relative;
`;
const WrapperAircraftDetails = styled.div`
	width: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
	padding-top: 12px;
`;
const WrapperConfiguration = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: center;
	padding: 10px 12px;
	gap: 16px;
	min-width: 100px;
	height: 38px;
	border: 1px solid #595959;
	border-radius: 4px;
	transition: all 0.6s ease-in-out;
	cursor: pointer;
	:hover {
		border: 1px solid #ffb11a;
	}
	${({ active }) =>
		active &&
		`
        border: 1px solid #ffb11a;
    `}
`;
const WrapperAicraftName = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	width: 100%;
`;
const WrapperMainImage = styled.div`
	width: 100vw;
	height: 80%;
	transition: height 0.25s ease-out;
	padding: 152px 0px 0px 0px;
	position: relative;
	.swiper-slide {
		background-position: center;
		background-size: cover;
		width: 50%;
		height: 100%;
	}
	.swiper-slide img {
		display: block;
		width: 100%;
	}
	.ant-image .ant-image-mask:hover {
		opacity: 0 !important;
	}
	.ant-image {
		z-index: 1;
		position: absolute;
	}
	.swiper-button-prev {
		left: 20% !important;
	}
	.swiper-button-next {
		right: 20% !important;
	}
	.swiper-button-prev::after,
	.swiper-button-next::after {
		content: "";
	}
`;
const WrapperThumbImages = styled.div`
	width: 100%;
	height: 20%;
	transition: height 0.25s ease-in;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
`;
const ArrowLeftButton = styled.div`
	cursor: pointer;
	position: absolute;
	left: 10px;
	top: 50%;
	bottom: 0;
`;
const ButtonClosePreview = styled.div`
	cursor: pointer;
	position: absolute;
	right: 20px;
	top: 20px;
`;
const ArrowRightButton = styled.div`
	cursor: pointer;
	position: absolute;
	right: 10px;
	top: 50%;
	bottom: 0;
`;
const WrapperIcon = styled.div`
	:hover {
		.ic-arrow-right-gray path {
			fill: #ffb11a;
		}
		.ic-arrow-right-gray rect {
			stroke: #ffb11a;
		}
		.ic-arrow-left-gray path {
			fill: #ffb11a;
		}
		.ic-arrow-left-gray rect {
			stroke: #ffb11a;
		}
	}
`;
const WrapperExpandButton = styled.div`
	cursor: pointer;
	position: absolute;
	right: 16px;
	top: 16px;
	bottom: 0;
	z-index: 10;
`;
const WrapperInsideExpand = styled.div`
	:hover {
		.ic-expand path {
			fill: #ffb11a;
		}
		.ic-expand rect {
			stroke: #ffb11a;
		}
	}
`;
